export default "__VITE_ASSET__awvqFzmT__"